import { render, staticRenderFns } from "./InsumoBuscar.vue?vue&type=template&id=16f21882&"
import script from "./InsumoBuscar.vue?vue&type=script&lang=js&"
export * from "./InsumoBuscar.vue?vue&type=script&lang=js&"
import style0 from "./InsumoBuscar.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports